import React from "react";

class KeyboardPeripheralInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      raw: ""
    };

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  componentDidMount() {
    this.interval = setInterval(() => this.peripheralInput.focus(), 100);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  onChange(e) {
    this.setState({ raw: e.target.value });
  }

  onBlur() {
    setTimeout(() => {
      this.input && this.input.focus();
    }, 10);
  }

  onKeyDown(e) {
    if (e.keyCode === 13 && this.state.raw) {
      this.props.onChange(this.state.raw.trim());
    }
  }

  render() {
    return (
      <div
        style={{
          width: 0,
          overflow: "hidden"
        }}
      >
        <input
          id="CreditCardEntry--input"
          ref={ref => (this.peripheralInput = ref)}
          type="text"
          onChange={this.onChange}
          onBlur={this.onBlur}
          onKeyDown={this.onKeyDown}
          value={this.state.raw}
        />
      </div>
    );
  }
}

export default KeyboardPeripheralInput;



// WEBPACK FOOTER //
// ./src/app/components/partials/keyboard-peripheral-input.jsx